<div class="card-container">
  <div class="flex column gap-10px mr-7 mb-27">
    <div class="flex flex-row space-between">
      <div class="flex row-collapse gap-md-12px gap-sm-5px">
        <div class="contact-label flex">{{ 'profiles.contact.contacted' | translate | titlecase }}</div>
        <div class="flex">{{ profileContact.TalkedWith }}</div>
      </div>
      <div class="text-right flex">
        <strong>
          <span class="mr-27" [title]="profileContact.ContactDate">{{ profileContact.ContactDate | date: 'MM/dd/yyyy' }}
          </span>
        </strong>
        <action-button *ngIf="!menuDoesNotHaveAnyItems" styleClass="btn-primary" icon="pi pi-ellipsis-h"
          [items]="actionItems">
        </action-button>
      </div>
    </div>
    <div class="flex row-collapse gap-md-12px gap-sm-5px">
      <div class="contact-label flex">{{ 'profiles.contact.subject' | translate | titlecase }}</div>
      <div class="flex ">{{ profileContact.Subject }}</div>
    </div>
    <div class="flex row-collapse gap-md-12px gap-sm-5px">
      <div class="contact-label flex">{{ 'profiles.contact.description' | translate | titlecase }}</div>
      <div class="desc-overflow flex">
        <wl-html-content-view
          [html]="profileContact.Descr ? profileContact.Descr : profileContact.Message"></wl-html-content-view>
      </div>
    </div>
  </div>
  <div class="contact-card-footer">
    <div class="mct-flex mct-row mct-wrap mct-gap-12">
      <div class="contact-card-73px"></div>
      <div class="mct-flex mct-row mct-gap-12 mct-flex-1-1-auto">
        <div class="contact-label">
          {{ 'profiles.contact.type' | translate | titlecase }}
        </div>
        <div>
          {{ profileContact.ContactType | titlecase }}
        </div>
      </div>
      <div class="text-right mr-7 mct-flex-1-1-0">
        <span class="contact-label mr-12">{{ 'profiles.contact.by' | translate | titlecase }}</span> {{ profileContact.Contactee }}
      </div>
    </div>
  </div>
</div>

<wl-profile-contacts-analytics-dialog />
